import { IPayment } from "Dashboard/scenes/Expenses/domain/IPayment";
import { useAppDispatch } from "hooks/hooks";
import CancelIcon from "@mui/icons-material/Cancel";
import { grey } from "@mui/material/colors";
import { toast } from "react-toastify";
import { getExpensesList, setDeletePaymentModalOpen, updatePayment } from "../../Main/main.slice";
import { useState } from "react";
import DatePicker from "react-datepicker";
import { FormatDateIso } from "utils/dateUtils";

interface IProps {
  payment: IPayment;
  index: number;
}

const PaymentRow = ({ payment, index }: IProps) => {
  const dispatch = useAppDispatch();
  const [amountValue, setAmountValue] = useState<number>(payment?.amount);
  const [amountStored, setAmountStored] = useState<number>(payment?.amount);

  const [noteValue, setNoteValue] = useState<string>(payment?.note);
  const [noteStored, setNoteStored] = useState<string>(payment?.note);

  const [dateValue, setDateValue] = useState<Date>(new Date(payment?.date));

  const handleAmountBlur = async () => {
    try {
      if (amountValue !== amountStored) {
        setAmountStored(amountValue);
        await dispatch(updatePayment({ expenseId: payment.expenseId, paymentId: payment.paymentId, data: { amount: amountValue } }));
        dispatch(getExpensesList());
        toast.success("Iznos plaćanja je uspešno izmenjen.");
      }
    } catch (error) {
      console.error("Error updating payment amount:", error);
    }
  }

  const handleNoteBlur = async () => {
    try {
      if (noteValue !== noteStored) {
        setNoteStored(noteValue);
        await dispatch(updatePayment({ expenseId: payment.expenseId, paymentId: payment.paymentId, data: { note: noteValue } }));
        toast.success("Napomena plaćanja je uspešno izmenjena.");
      }
    } catch (error) {
      console.error("Error updating payment note:", error);
    }
  }

  const handleDateChange = async (date: Date | null) => {
    if (date != null) {
      setDateValue(date);
      await dispatch(updatePayment({ expenseId: payment.expenseId, paymentId: payment.paymentId, data: { date: FormatDateIso(date) } }));
      dispatch(getExpensesList());
    }
  }

  return (
    <div className="row">
      <div className="col center">
        <span onClick={e => {
          e.stopPropagation();
          dispatch(setDeletePaymentModalOpen({ visible: true, index }));
        }}>
          <CancelIcon
            style={{ cursor: "pointer", fontSize: 15, color: grey[300] }}
          />
        </span>
      </div>
      <div className="col">
        <div className="bg-item-border-light">
          <DatePicker
            dateFormat="dd.MM.yyyy"
            showMonthDropdown
            showYearDropdown
            onChange={handleDateChange} // Call handleDateChange when the date changes
            selected={dateValue}
            isClearable={false}
          />
        </div>
      </div>
      <div className="col">
        <div className="bg-item">
          <input
            onBlur={handleAmountBlur}
            onChange={(e) => { setAmountValue(parseInt(e.target.value)) }}
            value={`${amountValue} rsd`} />
        </div>
      </div>
      <div className="col">
        <div className="bg-item-border-light">
          <input
            onBlur={handleNoteBlur}
            onChange={(e) => { setNoteValue(e.target.value) }}
            value={noteValue} />
        </div>
      </div>
    </div>
  );
};


export default PaymentRow;
